import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from '@/router/router'
import store from './vuex/store'
import './registerServiceWorker'
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

import EditableField from '@/components/EditableField'
import SvPageTitle from '@/components/SvPageTitle'
import SvHeader from '@/components/SvHeader'
import SvAvatar from '@/components/SvAvatar'
import OpeningTimes from '@/components/OpeningTimes'
import Maps from '@/components/Maps'
import ContactInfo from "@/components/ContactInfo";
import CompanyInfo from "@/components/CompanyInfo";

Vue.use(VueFire)
firebase.initializeApp({
  apiKey: "AIzaSyD95o1PlOvNeDh8fYqqf2nv5dMWFnMYXIw",
  authDomain: "sanavita-f56af.firebaseapp.com",
  databaseURL: "https://sanavita-f56af.firebaseio.com",
  projectId: "sanavita-f56af",
  storageBucket: "sanavita-f56af.appspot.com",
  messagingSenderId: "617348146808"
})
const settings = {timestampsInSnapshots: true};
firebase.firestore().settings(settings);
export const db = firebase.firestore()

Vue.config.productionTip = false

Vue.component('editable-field', EditableField)
Vue.component('sv-page-title', SvPageTitle)
Vue.component('sv-avatar', SvAvatar)
Vue.component('sv-header', SvHeader)
Vue.component('opening-times', OpeningTimes)
Vue.component('maps', Maps)
Vue.component('contact-info', ContactInfo)
Vue.component('company-info', CompanyInfo)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
